export var last = function last(array) {
  return array[array.length - 1];
};
export var padZeroNumber = function padZeroNumber(value) {
  return "".concat(value).padStart(2, '0');
};
/**
 * Форматирование названия месяца.
 * Если не передавать `day`, то название месяца будет, например, `июнь`.
 * В данном случае вернется `июня`.
 * Так же результат выполнения метода `formatToParts` является массивом,
 * в котором находятся части даты, форматированной на основнии `options`.
 * То есть в данном случае вернется массив [`day`, `separator`, `month`]
 */

export var monthName = function monthName(val, monthFormat) {
  var targetMonth = new Date(2000, val, 1);
  return last(new Intl.DateTimeFormat('ru-RU', {
    day: 'numeric',
    month: monthFormat
  }).formatToParts(targetMonth)).value;
};
export var monthLongName = function monthLongName(val) {
  return monthName(val, 'long');
};
export var monthShortName = function monthShortName(val) {
  return monthName(val, 'short').replace('.', '');
};